import { Component, ChangeDetectionStrategy } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";

import type { ICellRendererAngularComp } from "ag-grid-angular";
import type { ICellRendererParams } from "ag-grid-community";

import { driveFileUrlFromId } from "@dis/gapi";

@Component({
  selector: "file-cell-renderer",
  imports: [MatIconModule],
  template: `
    @if (fileUrl) {
      <a
        [href]="fileUrl"
        target="_blank"
        rel="external noopener noreferrer"
        class="file-link"
        (click)="$event.stopPropagation()"
      >
        <mat-icon aria-label="file link icon">link_2</mat-icon>
      </a>
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      :host {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
      }

      .file-link {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    `,
  ],
})
export class FileCellRenderer implements ICellRendererAngularComp {
  public fileUrl: string = "";

  agInit(params: ICellRendererParams): void {
    this.refresh(params);
  }

  refresh(params: ICellRendererParams): boolean {
    const fileId = params.value;
    if (fileId) {
      this.fileUrl = driveFileUrlFromId(fileId);
    }
    return true;
  }
}
